import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function depositOrder(data) {
    try {
        const response = await serviceContext.post("pgi/orders/", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getDepositOrderDetails(data) {
    try {
        const response = await serviceContext.get("pgi/orders/" + data, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getWithdrawOrderDetails(data) {
    try {
        const response = await serviceContext.get("pgi/withdrawals/" + data, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function withdrawalOrder(data) {
    try {
        const response = await serviceContext.post("pgi/withdrawals/", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getWithdrawalOrderDetails(data) {
    try {
        const response = await serviceContext.get("pgi/withdrawals/" + data, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getDepositWithdrawalReport(data) {
    try {
        const response = await serviceContext.post(`${ReportsURL}payment/user`, JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getBeneficiaryAccounts() {
    try {
        const response = await serviceContext.get("pgi/beneficiaryaccounts", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function deleteBeneficiaryAcc(id) {
    try {
        const response = await serviceContext.remove(`pgi/beneficiaryaccounts/${id}`, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    } catch (error) {
        return error;
    }
}


export async function sendOtp(bool) {
    try {
        const response = await serviceContext.post(`pgi/otp/sendotp/${bool}`, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    } catch (error) {
        return error;
    }
}

export async function addBeneficiaryAcc(body) {
    try {
        const response = await serviceContext.post(`pgi/beneficiaryaccounts`, JSON.stringify(body), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    } catch (error) {
        return error;
    }
}